import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import SplitType from 'split-type';
import collage from '../../../blocks/collage/scripts/collage';
import logoSlider from '../../../blocks/logo-slider/scripts/logo-slider';
import cAppeared from '../components/c-appeared';

gsap.registerPlugin(ScrollTrigger);

export default function () {
  collage();
  logoSlider();
  cAppeared();

  let isPreloaderDone = false;
  document.addEventListener('preloaderDone', () => {
    isPreloaderDone = true;
  });

  const servicesLists = document?.querySelectorAll('[data-services-list]');
  servicesLists.forEach((list) => {
    const servicesListHeading = list.querySelector('[data-services-list-heading]');
    const servicesListTitle = list.querySelector('[data-services-list-title]');
    const servicesListSeparator = list.querySelectorAll('[data-services-list-separator]');
    const servicesListItem = list.querySelectorAll('[data-services-list-item]');

    if (servicesListHeading) {
      const words = servicesListHeading.textContent.split(' ');
      if (words.length >= 3) {
        const lastThreeWords = words.slice(-3).join(' ');
        servicesListHeading.innerHTML = servicesListHeading.innerHTML.replace(lastThreeWords, `<span class="services-list__heading-word">${lastThreeWords}</span>`);
      }

      // eslint-disable-next-line no-new
      new SplitType(servicesListHeading);
    }

    if (servicesListTitle && servicesListSeparator && servicesListItem) {
      gsap.set(servicesListTitle, { y: -40, autoAlpha: 0 });
      gsap.set(servicesListSeparator, { scale: 0 });
      gsap.set(servicesListItem, { x: -40, autoAlpha: 0 });
    }

    const runAnimation = () => {
      if (servicesListTitle && servicesListSeparator && servicesListItem) {
        gsap.timeline({
          scrollTrigger: {
            trigger: list,
            start: 'top 75%',
          },
        }).to(servicesListHeading?.querySelectorAll('.char'), {
          y: 0,
          autoAlpha: 1,
          stagger: 0.01,
          delay: 0.1,
          duration: 0.1,
        })
          .to(servicesListTitle, {
            y: 0,
            autoAlpha: 1,
            duration: 0.4,
          })
          .to(servicesListSeparator, {
            scale: 1,
            duration: 1,
          })
          .to(servicesListItem, {
            x: 0,
            autoAlpha: 1,
            stagger: 0.2,
          }, '<');
      }
    };

    if (isPreloaderDone || sessionStorage.getItem('preloaderDone')) {
      runAnimation();
    } else {
      document.addEventListener('preloaderDone', runAnimation);
    }
  });

  const quoteBlocks = document.querySelectorAll('[data-quote]');
  quoteBlocks.forEach((quote) => {
    const spitText = quote.querySelector('[data-split-text]');
    const bottom = quote.querySelector('[data-contact-bottom]');

    // eslint-disable-next-line no-new
    if (spitText) new SplitType(spitText);

    // Create a timeline for the quote animation
    gsap.timeline({
      scrollTrigger: {
        trigger: quote,
        start: 'top 75%',
      },
    }).to(spitText.querySelectorAll('.char'), {
      y: 0,
      stagger: 0.01,
      delay: 0.1,
      duration: 0.1,
    }).fromTo(bottom, { opacity: 0, y: -15 }, { opacity: 1, y: 0 });
  });

  const ctaBlocks = document?.querySelectorAll('[data-cta]');
  ctaBlocks.forEach((cta) => {
    const ctaTitle = cta.querySelector('[data-cta-title]');
    const ctaButton = cta.querySelector('[data-cta-button]');

    // eslint-disable-next-line no-new
    new SplitType(ctaTitle);

    gsap.timeline({
      scrollTrigger: {
        trigger: cta,
        start: 'top 75%',
      },
    }).to(ctaTitle.querySelectorAll('.char'), {
      y: 0,
      stagger: 0.01,
      delay: 0.1,
      duration: 0.1,
    }).fromTo(ctaButton, { opacity: 0, y: -15 }, { opacity: 1, y: 0 }, '+=.5');
  });
}
